import React from 'react';
import Button from '../common/components/Button';
import BackIcon from  '../../assests/img/left-angle-bracket.svg?react';

interface manageContentLayoutProps {
    header: string,
    headerCtaOnClick: () => void,
    showHeaderCta?: boolean,
    topContent: React.ReactNode,
    bottomContentHeader: string,
    bottomContent: React.ReactNode,
    ctaConfig: {
        primaryCtaText: string,
        primaryCtaOnClick: () => void,
        primaryCtaDisable?: boolean,
        secondaryCta1Text: string,
        secondaryCta1OnClick: () => void,
        secondaryCta1Disable?: boolean,
        secondaryCta2Text: string,
        secondaryCta2OnClick: () => void,
        secondaryCta2Disable?: boolean,
    },
}

function ManageContentLayout(props: manageContentLayoutProps) {
    const {header, topContent, bottomContentHeader, bottomContent,
        ctaConfig, showHeaderCta, headerCtaOnClick} = props;

    return (
        <div className='manage-user-detail-page'>
            <div className='manage-user-detail-header'>
                {showHeaderCta ? 
                    <div onClick={headerCtaOnClick} className='cta-cursor px-2 d-flex align-items-center justify-content-center'>
                        <BackIcon/>
                    </div> :
                null }
                <span className='ms-1'>{header}</span>
            </div>
                <div className='manage-user-detail-content'>
                <div className='manage-user-top-content'>
                    {topContent}
                    <div className='d-flex align-items-center gap-2'>
                        <Button buttonText={ctaConfig.secondaryCta2Text} onClick={ctaConfig.secondaryCta2OnClick} type='secondary'
                        disable={ctaConfig.secondaryCta2Disable}/>
                        <Button buttonText={ctaConfig.secondaryCta1Text} onClick={ctaConfig.secondaryCta1OnClick} type='secondary'
                        disable={ctaConfig.secondaryCta1Disable}/>
                        <Button buttonText={ctaConfig.primaryCtaText} onClick={ctaConfig.primaryCtaOnClick} type='primary' disable={ctaConfig.primaryCtaDisable}/>
                    </div>
                </div>
                <div className='manage-user-bottom-content'>
                    <div className='manage-user-bottom-content-header'>     
                        {bottomContentHeader}
                    </div>
                    {bottomContent}
                </div>
            </div>
        </div>
    );
}

export default  ManageContentLayout;
